import React from 'react'

function Games() {
  return (
    <div className="big-display">
        <div><i className="fa-solid fa-chess fa-3x"></i></div>
        <div className='heading1'>Games</div>
    </div>
  )
}

export default Games